module.exports = __webpack_public_path__ + "static/media/YF58_5.8e57bd56.jpg";